import hiveclass from '../img/hiveclass/hiveclass.png';

const jobs = [
  {
    name: 'Hiveclass',
    slug: 'hiveclass',
    subtitle: "Backend Engineer",
    logo: hiveclass,
    logo_alt: 'hiveclass',
    date_start: 'June 2023',
    date_end: 'Present',
    tech_stack: [
      'SQL',
      'Omni Analytics',
      'TypeScript',
      'Drizzle ORM',
    ],
    bullets: [
      "Leading the design of a normalized database schema and coordinating a full data migration using TypeScript and Drizzle ORM to support an overhauled product with 25+ tables, resolving technical debt and ensuring strict relational integrity",
      "Establishing the company's first data analytics pipeline using Omni Analytics to aggregate 2M+ rows of business data",
      "Developing 20+ Express.js endpoints to support product features, including a teacher portal for the retrieval of complex data",
      "Collaborating with cross-functional stakeholders to automate workflows and provide training for streamlined operations",
    ]
  }
]

export default jobs;
